import { IconSound, IconDelete } from '@bynder/icons';
import { Button, Card, List } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { useActiveWidget } from '../../../../queries/guides';
import {
  AudioWidget,
  CVAsset,
  ModalType,
  WIDGET_TYPE,
} from '../../../../types';
import { AssetType } from '../../../../types/assetTypes';
import { useAudioWidgetMutations } from '../../../../mutations/widgets/audio';
import { WidgetSettingsHeader } from '../../Styles';
import { useInspectorStore } from '../../../../stores/inspectorStore';
import { useModalStore } from '../../../../stores/modalStore';

export const AudioWidgetSettings = () => {
  const { translate } = useTranslate();
  const openModal = useModalStore.use.openModal();
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const audioWidget = useActiveWidget() as AudioWidget;
  const { updateAudioWidget } = useAudioWidgetMutations(
    widgetSettings.sectionId,
    widgetSettings.columnIndex,
    widgetSettings.widgetId,
  );
  const addAudioAsset = (selectedMedia: CVAsset[]) => {
    if (selectedMedia.length) {
      const { databaseId, name, url, originalUrl } = selectedMedia[0];

      updateAudioWidget.mutate({
        assetId: databaseId,
        assetName: name,
        audioUrl: originalUrl,
        detailUrl: url,
      });
    }
  };

  const handleClick = () => {
    openModal({
      modalType: ModalType.COMPACT_VIEW_MODAL,
      modalOnSubmit: addAudioAsset,
      modalProps: {
        compactViewProps: {
          assetTypes: [AssetType.AUDIO],
        },
      },
    });
  };

  const clearAudio = () => {
    updateAudioWidget.mutate({
      assetId: '',
      assetName: '',
      audioUrl: '',
      detailUrl: '',
    });
  };

  return (
    <>
      <WidgetSettingsHeader widgetType={WIDGET_TYPE.AUDIO} />
      <List>
        {audioWidget.assetName ? (
          <Card
            variant="clean"
            onClick={handleClick}
            contextAction={
              <Card.ContextActionButton
                tooltip={translate('WIDGET_INSPECTOR.CLEAR_AUDIO_BUTTON')}
                aria-label="Clear audio"
                onClick={clearAudio}
              >
                <IconDelete />
              </Card.ContextActionButton>
            }
          >
            <Card.Frame>
              <Card.IconPlaceholder>
                <IconSound aria-label="coverIcon" />
              </Card.IconPlaceholder>
            </Card.Frame>
            {audioWidget?.assetName && (
              <Card.Header title={audioWidget.assetName} />
            )}
          </Card>
        ) : (
          <Button
            onClick={handleClick}
            isFullWidth
            variant="secondary"
            icon={<IconSound />}
          >
            {translate('WIDGET_INSPECTOR.EMPTY_AUDIO_WIDGET_BUTTON')}
          </Button>
        )}
      </List>
    </>
  );
};
